import styled from 'styled-components';

import { Dropdown } from '@components/_universal/Dropdown/Dropdown';

export const ProfileDropdownWrapper = styled(Dropdown)`
    display: flex;
    flex-direction: column;
    padding: 24px 24px 16px;
    width: 330px;
`;
